export default __webpack_public_path__ + "static/media/dou.b037af31.png";